import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as notifications } from 'react-notification-system-redux'

import auth from './auth'
import workOrders from './work-orders'
import areas from './areas'
import calendarFilters from './calendar-filters'
import comments from './comments'
import contracts from './contracts'
import inspectionFilters from './inspection-filters'
import pins from './pins'
import locations from './locations'
import allLocations from './all-locations'
import messages from './messages'
import technicians from './technicians'
import technicianServicingVersions from './technician-servicing-versions'
import qaServicings from './qa-servicings'
import qaWorkOrders from './qa-work-orders'
import reports from './reports'
import services from './services'
import servicings from './servicings'
import settings from './settings'
import subLocations from './sub-locations'
import technicianServiceSummaries from './technician-service-summaries'
import workTrackerFilters from './work-tracker-filters'
import entitiesReducer, { stubbedEntityReducers } from './entities-reducer'

import pagination from './pagination'

const rootReducer = combineReducers({
  // combineReducers gets mad if there aren't handlers for EVERY possible state key.
  ...stubbedEntityReducers,

  form: formReducer,
  notifications,
  routing: routerReducer,
  areas,
  auth,
  calendarFilters,
  comments,
  contracts,
  locations,
  allLocations,
  inspectionFilters,
  messages,
  pins,
  qaServicings,
  qaWorkOrders,
  reports,
  services,
  servicings,
  settings,
  subLocations,
  technicianServiceSummaries,
  technicianServicingVersions,
  technicians,
  workOrders,
  workTrackerFilters,
  pagination
})

export default (state, action) => {
  return rootReducer(entitiesReducer(state, action), action)
}



// WEBPACK FOOTER //
// ./src/reducers/index.js